import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import Swup from 'swup';
import Fancybox from '@fancyapps/fancybox';
//import $ from 'jquery';
import swupRenderPage from './swupRenderPage.js';

import '../components/popup-searchform/jquery.autocomplete.min.js';

import '../components/field-date/field-date.js';
import '../components/same-height/same-height.js';
//import '../components/main-menu/main-menu.js';
import '../components/popup-searchform/popup-searchform.js';
import '../components/image-compare/image-compare.js';
import '../components/maincontent/maincontent.js';
import '../components/form/form.js';
import '../components/loadmore/loadmore.js';
import '../components/navbar/navbar.js';
import '../components/axes/axes.js';
import '../components/video/video.js';
import '../components/map/map.js';
import '../components/mobile-menu/mobile-menu.js';
import '../components/uk-accordion/accordion.js';
import '../components/img-on-pattern/img-on-pattern.js';
import '../components/loader/loader.js';
import '../components/bodymovin/bodymovin.js';
import '../components/programs-list/programs-list.js';
import '../components/program-popup/program-popup.js';
import '../components/news-list/news-list.js';
import '../components/project-list/project-list.js';

// loads the Icon plugin
UIkit.use(Icons);
// components can be called from the imported UIkit reference
//UIkit.notification('Hello world.');

const options = {
    animateHistoryBrowsing: false,
    //animationSelector: '[class*="transition-"]',
    containers: ['#swup','#wpadminbar', '.ancr-container'],
    cache: false,
    linkSelector: 'a[href^="' + window.location.origin + '"]:not([data-no-swup]), a[href^="/"]:not([data-no-swup]), a[href^="#"]:not([data-no-swup]):not([href$="#"])',
    animationSelector: '[class*="px-trans-"]'
};

const swup = new Swup(options);
swup.renderPage = swupRenderPage;
swup._handlers.loaderProgress = [];

jQuery(function() {
    //window.dispatchEvent(new Event('px-ready'));
    //UIkit.offcanvas.hide()
    jQuery('.fancybox').fancybox();
    var cookie = getCookie('pxanimseen');
    var today = new Date();
    var dateStr = String(today.getFullYear())+' '+String(today.getMonth())+' '+String(today.getDay())
    if(cookie == dateStr){
        jQuery('.px-loader').attr('style','display:none;');
    }else{
        setCookie('pxanimseen',dateStr,30)
    }
    jQuery('body').css('opacity',1);
    window.setTimeout(function(){
        jQuery('html').removeClass('is-animating')
        jQuery('html').attr('style','');
    },30)
    var event;
    if(typeof(Event) === 'function') {
        event = new Event('px-ready');
    }else{
        event = document.createEvent('Event');
        event.initEvent('px-ready', true, true);
    }
  
    window.dispatchEvent(event);
});
swup.on('loaderProgress', function(){
    var d=new Date()
    //console.log(swup.progress.percent + ' ' + d.getSeconds() + '.' + d.getMilliseconds());
    if(swup.progress.percent<100){
        //jQuery('.px-loader').css('opacity',1);
        jQuery('body').addClass('is-loading');
        jQuery('body').addClass('is-animating');
        jQuery('.px-loader .bar').css('width',100-swup.progress.percent+'%');
        jQuery('.px-loader .bar').css('opacity',1);
    }else{
        jQuery('.px-loader .bar').css('width','0%');
        //jQuery('.px-loader .bar').css('opacity',0);
        window.setTimeout(function(){
            jQuery('body').removeClass('is-loading');
            //jQuery('.px-loader .bar').css('opacity',0);
            var event;
            if(typeof(Event) === 'function') {
                event = new Event('px-loaderend');
            }else{
                event = document.createEvent('Event');
                event.initEvent('px-loaderend', true, true);
            }
            window.dispatchEvent(event);
        },500)
        //jQuery('.px-loader').css('width','100%');
        /*window.setTimeout(function(){
            jQuery('.px-loader .bar').css('width','100%');
            jQuery('.px-loader .bar').css('opacity',1);
        },10000)*/
    }
});
var isBackButton = false;
swup.on('contentReplaced', function(){
    window.dispatchEvent(new Event('px-ready'));
    //console.log('close offcanvas')
    //UIkit.offcanvas('#offcanvasmenu').hide();
    //console.log('navtype '+window.performance.navigation.type);
    if(isBackButton) {console.log('is back/forward');
        isBackButton = false;
        window.setTimeout(function(){jQuery('html').removeClass('is-animating');},400);
    }
    else{
        //console.log('is-nav')
        jQuery('html,body').animate({scrollTop:0},0);
        //jQuery('body').addClass('is-loading');
    }
});
swup.on('animationOutStart', function(e){
    //console.log(e);
    var event;
    if(typeof(Event) === 'function') {
        event = new Event('px-navigationstart');
    }else{
        event = document.createEvent('Event');
        event.initEvent('px-navigationstart', true, true);
    }
    window.dispatchEvent(event);
})
swup.on('clickLink', function(e){
    console.log('clicklink');
    var urlTo = jQuery(e.target).attr('href');
    //console.log(urlTo);
    //console.log(window.location.hostname);
    if(!urlTo){
        var finda = jQuery(e.target).closest('a');
        urlTo = finda.attr('href');
        //console.log(finda.attr('href'))
        //console.log('needed closest')
    }
    urlTo = urlTo.replace("http://","");
    urlTo = urlTo.replace("https://","");
    urlTo = urlTo.replace(window.location.hostname,"");
    console.log(urlTo)
    if(urlTo == '' || urlTo == '/' || urlTo == '/fr/' || urlTo == '/fr'){
        //jQuery('body').addClass('js-is-home');
    }else{
        jQuery('body').removeClass('js-is-home');
    }
    window.setTimeout(function(){
        //if(urlTo != )
        var href= window.location.href;
        href = href.replace("http://","");
        href = href.replace("https://","");
        href = href.replace(window.location.hostname,"");
        //console.log(href);
        /*if(href != urlTo && href != urlTo + '/' && href+'/' != urlTo){
            jQuery('body').addClass('is-animating');
        }*/
    },50)
})
swup.on('popState', function () {
    //console.log('PopState');
    isBackButton = true;
    //jQuery('html').addClass('is-animating');
});

console.log('Webpack loaded!');

window.addEventListener('px-ready',function(){
    if(window.location.hash) {
        console.log(window.location.hash)
        //jQuery(window.location.hash).scrollIntoView(true);
        window.setTimeout(()=>{
            jQuery([document.documentElement, document.body]).animate({
                scrollTop: jQuery(window.location.hash).offset().top
            }, 1);
        },100)
    }
    jQuery(document).on('click', 'a[href^="#"]', function (event) {
        //console.log('x');
        //console.log('scroller');
        if(!jQuery(this).hasClass("uk-accordion-title") && !jQuery(this).attr('uk-slider-item')){
            event.preventDefault();

            var scrolltop = 0;
            if(jQuery(this).attr('href') != '#' && jQuery(this).attr('data-noscrollup') != '1'){
                scrolltop = jQuery(jQuery(this).attr('href')).offset().top;
            }
        
            jQuery('html, body').animate({
                scrollTop: scrolltop
            }, 350);
        }
    });
    window.setTimeout(function(){
        if(jQuery('.g-recaptcha').length && !jQuery('.g-recaptcha>*').length){
            window.location.reload();
        }
    },100)
})

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}
function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }